module.exports = __webpack_public_path__ + "media/images/weather/402_night-0fccd60d7803311d6ec8bb16780e6977.png";